<div>
    <h2 class="title" [ngClass]="font?.size">{{ faqData?.title }}</h2>
    <p class="subtitle" [ngClass]="font?.size">{{ faqData?.subTitle }}</p>
    <div class="faqs-section">
        <app-accordion-list [list]="faqData?.faq" [loading]="loading"></app-accordion-list>
    </div>
</div>